export const COMMISSION_RATE = 0.12 // 12% platform fee
export const COUNTRY_CURRENCIES = {
  'Australia': { code: 'AUD', symbol: '$', name: 'Australian Dollar' },
  'United States': { code: 'USD', symbol: '$', name: 'US Dollar' },
  'United Kingdom': { code: 'GBP', symbol: '£', name: 'British Pound' },
  'Canada': { code: 'CAD', symbol: '$', name: 'Canadian Dollar' },
  'New Zealand': { code: 'NZD', symbol: '$', name: 'New Zealand Dollar' },
  'Europe': { code: 'EUR', symbol: '€', name: 'Euro' },
  'Germany': { code: 'EUR', symbol: '€', name: 'Euro' },
  'France': { code: 'EUR', symbol: '€', name: 'Euro' },
  'Italy': { code: 'EUR', symbol: '€', name: 'Euro' },
  'Spain': { code: 'EUR', symbol: '€', name: 'Euro' },
  'Netherlands': { code: 'EUR', symbol: '€', name: 'Euro' },
  'Japan': { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  'China': { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  'India': { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  'Singapore': { code: 'SGD', symbol: '$', name: 'Singapore Dollar' },
  'Hong Kong': { code: 'HKD', symbol: '$', name: 'Hong Kong Dollar' },
  'South Africa': { code: 'ZAR', symbol: 'R', name: 'South African Rand' },
  'Brazil': { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  'Mexico': { code: 'MXN', symbol: '$', name: 'Mexican Peso' },
  'UAE': { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
}

export const getCurrency = (country) => {
  return COUNTRY_CURRENCIES[country] || { code: 'USD', symbol: '$', name: 'US Dollar' }
}

export const formatCurrencyByCountry = (amount, country) => {
  const currency = getCurrency(country)
  return new Intl.NumberFormat('en', { 
    style: 'currency', 
    currency: currency.code,
    minimumFractionDigits: 2
  }).format(amount)
}


export const CATEGORIES = [
{ id: 20, name: 'Art & Craft', icon: '🎨', slug: 'art-craft' },
{ id: 6, name: 'Baby & Kids', icon: '👶', slug: 'baby-kids' },
{ id: 30, name: 'BBQ & Outdoor Cooking', icon: '🔥', slug: 'bbq-outdoor-cooking' },
{ id: 14, name: 'Building & Construction', icon: '🏗️', slug: 'building-construction' },
{ id: 5, name: 'Camping & 4WD', icon: '🏕️', slug: 'camping-4wd' },
{ id: 9, name: 'Cars, Bikes & Trucks', icon: '🚗', slug: 'cars-bikes-trucks' },
{ id: 15, name: 'Cleaning & Maintenance', icon: '🧹', slug: 'cleaning-maintenance' },
{ id: 18, name: 'Cooling & Heating', icon: '❄️', slug: 'cooling-heating' },
{ id: 19, name: 'Costumes & Props', icon: '🎭', slug: 'costumes-props' },
{ id: 16, name: 'Education & Learning', icon: '🎓', slug: 'education-learning' },
{ id: 17, name: 'Fashion & Accessories', icon: '👗', slug: 'fashion-accessories' },
{ id: 21, name: 'Farm & Agriculture', icon: '🚜', slug: 'farm-agriculture' },
{ id: 2, name: 'Garden & Outdoor', icon: '🌿', slug: 'garden-outdoor' },
{ id: 11, name: 'Gaming & Tech', icon: '🎮', slug: 'gaming-tech' },
{ id: 31, name: 'Generators & Power', icon: '⚡', slug: 'generators-power' },
{ id: 28, name: 'Gym Equipment', icon: '💪', slug: 'gym-equipment' },
{ id: 10, name: 'Home & DIY', icon: '🏠', slug: 'home-diy' },
{ id: 3, name: 'Kitchen & Appliances', icon: '🍗', slug: 'kitchen-appliances' },
{ id: 22, name: 'Marine & Watercraft', icon: '🚤', slug: 'marine-watercraft' },
{ id: 23, name: 'Medical & Mobility', icon: '🔬', slug: 'medical-mobility' },
{ id: 12, name: 'Music & Performance', icon: '🎸', slug: 'music-performance' },
{ id: 29, name: 'Office & Workspace', icon: '💼', slug: 'office-workspace' },
{ id: 4, name: 'Party & Events', icon: '🎪', slug: 'party-events' },
{ id: 13, name: 'Pets & Animals', icon: '🐾', slug: 'pets-animals' },
{ id: 8, name: 'Photography & Audio Visual', icon: '📷', slug: 'photography-av' },
{ id: 24, name: 'Pool & Spa', icon: '🏊', slug: 'pool-spa' },
{ id: 7, name: 'Sports & Fitness', icon: '🏋️', slug: 'sports-fitness' },
{ id: 32, name: 'Storage & Moving', icon: '🧰', slug: 'storage-moving' },
{ id: 1, name: 'Tools & Hardware', icon: '🔧', slug: 'tools-hardware' },
{ id: 27, name: 'Trailers & Caravans', icon: '🚛', slug: 'trailers-caravans' },
{ id: 25, name: 'Weddings & Formal', icon: '🎉', slug: 'weddings-formal' },
]

export const AU_STATES = ['ACT','NSW','NT','QLD','SA','TAS','VIC','WA']

export const BOOKING_STATUS = {
  pending: { label: 'Pending', color: '#BA7517', bg: '#FAEEDA' },
  confirmed: { label: 'Confirmed', color: '#185FA5', bg: '#E6F1FB' },
  active: { label: 'Active', color: '#2D3FCC', bg: '#E8EBFB' },
  completed: { label: 'Completed', color: '#5F5E5A', bg: '#F1EFE8' },
  cancelled: { label: 'Cancelled', color: '#A32D2D', bg: '#FCEBEB' },
  disputed: { label: 'Disputed', color: '#993C1D', bg: '#FAECE7' },
  enquiry: { label: 'Enquiry', color: '#5A6B7A', bg: '#EEF1F4' },
  paid: { label: 'Paid', color: '#1B7E4B', bg: '#E5F4EA' },
  collected: { label: 'Collected', color: '#6B3FBA', bg: '#EFE9F8' },
}

export const calcFees = (pricePerHour, hours, deposit = 0) => {
  const subtotal = pricePerHour * hours
  const platformFee = parseFloat((subtotal * COMMISSION_RATE).toFixed(2))
  const ownerPayout = parseFloat((subtotal - platformFee).toFixed(2))
  const total = parseFloat((subtotal + deposit).toFixed(2))
  return { subtotal, platformFee, ownerPayout, total, deposit }
}

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount)

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })

// Demo listings for testing without Supabase
export const DEMO_LISTINGS = [
  { id:'d1', title:'Lawn mower (petrol)', category_id:2, price_per_hour:12, deposit:50, postcode:'4000', suburb:'Brisbane CBD', state:'QLD', available:true, description:'4-stroke petrol mower. Cuts up to 1/4 acre. Full tank included. Clean and serviced regularly.', images:[], profiles:{ full_name:'Craig M', rating:4.9, review_count:23 } },
  { id:'d2', title:'Air fryer 8L (Ninja)', category_id:3, price_per_hour:8, deposit:30, postcode:'4000', suburb:'Brisbane CBD', state:'QLD', available:true, description:'Large Ninja air fryer. Perfect for parties and batch cooking. Includes recipe book and all accessories.', images:[], profiles:{ full_name:'Michelle T', rating:5.0, review_count:8 } },
  { id:'d3', title:'Caravan 18ft (Jayco)', category_id:5, price_per_hour:90, deposit:500, postcode:'4051', suburb:'Alderley', state:'QLD', available:true, description:'2021 Jayco Swan. Full annex, solar, hot water, queen bed. Sleeps 4. Full kitchen.', images:[], profiles:{ full_name:'Rod K', rating:4.8, review_count:41 } },
  { id:'d4', title:'Pressure washer 2400PSI', category_id:1, price_per_hour:15, deposit:40, postcode:'4020', suburb:'Redcliffe', state:'QLD', available:true, description:'Electric pressure washer. 10m hose, 4 nozzles. Great for driveways, decks, and fences.', images:[], profiles:{ full_name:'Sandra B', rating:4.7, review_count:15 } },
  { id:'d5', title:'Marquee 6x3m (white)', category_id:4, price_per_hour:20, deposit:100, postcode:'4064', suburb:'Milton', state:'QLD', available:true, description:'Professional white marquee. Includes sides, poles, pegs. Seats up to 30 guests. Easy setup.', images:[], profiles:{ full_name:'Dave P', rating:4.9, review_count:62 } },
  { id:'d6', title:'Stand mixer (KitchenAid)', category_id:3, price_per_hour:9, deposit:60, postcode:'4000', suburb:'Brisbane CBD', state:'QLD', available:true, description:'KitchenAid 5L stand mixer. All attachments included. Perfect for baking events and catering.', images:[], profiles:{ full_name:'Priya S', rating:5.0, review_count:19 } },
  { id:'d7', title:'Box trailer 6x4', category_id:9, price_per_hour:25, deposit:80, postcode:'4006', suburb:'New Farm', state:'QLD', available:true, description:'6x4 box trailer, 750kg rated. Ball coupling, safety chains. Braked. Suits most vehicles.', images:[], profiles:{ full_name:'Liam O', rating:4.6, review_count:33 } },
  { id:'d8', title:'Paddle boards x2 (SUP)', category_id:7, price_per_hour:20, deposit:100, postcode:'4005', suburb:'Fortitude Valley', state:'QLD', available:true, description:'Two 10ft inflatable SUPs with pumps, paddles and leashes. Perfect condition. Beginners welcome.', images:[], profiles:{ full_name:'Jess W', rating:4.9, review_count:28 } },
  { id:'d9', title:'Projector + 100" screen', category_id:8, price_per_hour:18, deposit:70, postcode:'4051', suburb:'Alderley', state:'QLD', available:true, description:'Epson 3500 lumen full HD projector + 100" screen. HDMI/wireless. Great for movie nights and presentations.', images:[], profiles:{ full_name:'Tom H', rating:4.8, review_count:11 } },
  { id:'d10', title:'Bouncy castle (kids)', category_id:4, price_per_hour:30, deposit:150, postcode:'4073', suburb:'Darra', state:'QLD', available:true, description:'Large kids bouncy castle. Blower included. Up to 8 kids. Suitable for ages 3-12. Clean after each hire.', images:[], profiles:{ full_name:'Amy C', rating:5.0, review_count:47 } },
  { id:'d11', title:'Concrete mixer 90L', category_id:14, price_per_hour:22, deposit:80, postcode:'4014', suburb:'Virginia', state:'QLD', available:true, description:'Electric 90L drum concrete mixer. Perfect for small slabs and post holes. Extension cord included.', images:[], profiles:{ full_name:'Pete R', rating:4.7, review_count:20 } },
  { id:'d12', title:'Carpet cleaner (Rug Doctor)', category_id:15, price_per_hour:14, deposit:50, postcode:'4030', suburb:'Lutwyche', state:'QLD', available:false, description:'Rug Doctor Pro deep cleaning machine. Solution included. Does full room in under an hour.', images:[], profiles:{ full_name:'Karen L', rating:4.8, review_count:35 } },
]

// Minimum / maximum hire choices for listing forms. Capped at 5 days to match
// the booking limit — a longer minimum would make a listing unbookable.
export const MIN_HIRE_OPTIONS = [
{ label: '1 hour', value: 1 },
{ label: '2 hours', value: 2 },
{ label: '3 hours', value: 3 },
{ label: '4 hours', value: 4 },
{ label: '5 hours', value: 5 },
{ label: '6 hours', value: 6 },
{ label: '7 hours', value: 7 },
{ label: '8 hours', value: 8 },
{ label: '9 hours', value: 9 },
{ label: '10 hours', value: 10 },
{ label: '11 hours', value: 11 },
{ label: '12 hours', value: 12 },
{ label: '1 day', value: 24 },
{ label: '2 days', value: 48 },
{ label: '3 days', value: 72 },
{ label: '4 days', value: 96 },
{ label: '5 days', value: 120 },
]
